module.exports = __webpack_public_path__ + "media/audios/kid/lesson_10/audio_tpc10_recompensa-c503358b3045747621414f0f22ea2d55.m4a";